module.exports = __webpack_public_path__ + "static/media/singapore-flag.0bcce81e.png";